"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchPdfStoredWorkflowOutputSchema = exports.FetchPdfWorkflowOutputSchema = exports.FetchPdfWorkflowInputSchema = exports.FETCH_PDF_WORKFLOW_NAME = void 0;
const zod_1 = require("zod");
exports.FETCH_PDF_WORKFLOW_NAME = 'fetchPdfWorkflow';
exports.FetchPdfWorkflowInputSchema = zod_1.z.object({
    url: zod_1.z.string(),
    timeoutMs: zod_1.z.number().optional(),
    bailIfHtmlAfterMs: zod_1.z.number().nullable().optional(),
    userAgent: zod_1.z.string().optional(),
    proxy: zod_1.z
        .object({
        server: zod_1.z.string(),
        username: zod_1.z.string().optional(),
        password: zod_1.z.string().optional(),
    })
        .optional(),
    presignGrant: zod_1.z.string().optional(),
});
exports.FetchPdfWorkflowOutputSchema = zod_1.z.object({
    statusCode: zod_1.z.number(),
    headers: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    body: zod_1.z.string(),
    fileName: zod_1.z.string().optional(),
});
exports.FetchPdfStoredWorkflowOutputSchema = zod_1.z.object({
    statusCode: zod_1.z.number(),
    headers: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    location: zod_1.z.string(),
    size: zod_1.z.number(),
    fileName: zod_1.z.string().optional(),
});
//# sourceMappingURL=fetch-pdf.contract.js.map